import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import AppMuiThemeProvider from "./theme/AppMuiThemeProvider";

import AppRoutes from "./routes/AppRoutes";

import "./styles/main.css";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppMuiThemeProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </AppMuiThemeProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
